import React from "react";

const AppNameContext: React.Context<string> = React.createContext("Dense Connectome");

export default AppNameContext;